var map = {
	"./de.png": 1032,
	"./en.png": 1033,
	"./es.png": 1034,
	"./fr.png": 1035,
	"./ja.png": 1036,
	"./mk.png": 1037,
	"./pt.png": 1038,
	"./tr.png": 1039,
	"./zh.png": 1040
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1031;


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/language-switcher/flags ^\.\/.*\.png$
// module id = 1031
// module chunks = 0